import React from 'react';
import { trackError } from '../services/analytics';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    trackError('dashboard', error && error.message ? error.message : String(error));
  }

  handleReload = () => {
    localStorage.removeItem('auth_client_id');
    localStorage.removeItem('auth_client_nom');
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#F8FAFC', fontFamily: 'Inter, system-ui, sans-serif', padding: '24px'
        }}>
          <div style={{
            background: 'white', padding: '36px', borderRadius: '16px', maxWidth: '500px',
            width: '100%', boxShadow: '0 20px 40px rgba(0,0,0,0.08)', textAlign: 'center',
            border: '1px solid #E2E8F0'
          }}>
            <div style={{ fontSize: '48px', marginBottom: '16px' }}>🛠️</div>
            <h2 style={{ fontSize: '20px', fontWeight: '800', color: '#0F172A', margin: '0 0 10px' }}>
              Une mise à jour est disponible
            </h2>
            <p style={{ fontSize: '14px', color: '#64748B', lineHeight: '1.5', margin: '0 0 24px' }}>
              L'application s'est rafraîchie suite à une mise à jour sur le serveur. Cliquez ci-dessous pour recharger l'interface en toute sécurité.
            </p>
            <button
              onClick={this.handleReload}
              style={{
                padding: '12px 24px', background: 'linear-gradient(135deg, #1D9E75, #10B981)',
                color: 'white', border: 'none', borderRadius: '8px', fontSize: '14px',
                fontWeight: '700', cursor: 'pointer', boxShadow: '0 4px 12px rgba(29, 158, 117, 0.2)'
              }}
            >
              🔄 Réinitialiser et Recharger l'Application
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
